export default __webpack_public_path__ + "static/media/icon_info.e3aab036.svg";